import React, { useEffect } from "react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import Circle from "../../../../../../Assets/Images/sm-Circle.svg";
import { Config } from "../../../../../../Config";
import FormHead from "../SharedComponents/DesktopFormHead";
import RotatorIcon from "../../../../../../Assets/Images/EclipseSpinner.svg";
import axios from "axios";
import UnsavedChangesModal from "../../Components/UnsavedChangesModal";
import MobileStep1 from "../SharedComponents/MobileStep1";
import MobileStep2 from "../SharedComponents/MobileStep2";
import Collapsible from "react-collapsible";

const MobileView = (props) => {
  const [Title, setTitle] = useState("");
  const [ActiveStep, setActiveStep] = useState(1);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [JPACreated, setJPACreated] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [CreatedJPAId, setCreatedJPAId] = useState();
  const [SelectedLanguages, setSelectedLanguages] = useState([]);
  const [SelectedLocations, setSelectedLocations] = useState([]);
  const [SelectedSkills, setSelectedSkills] = useState([]);
  const [SelectedEd, setSelectedEd] = useState([]);
  const [HasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [ModalIsOpen, setModalIsOpen] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const goBack = () => {
    if (HasUnsavedChanges) {
      setModalIsOpen(true);
    } else {
      document.getElementById("back-link").click();
    }
  };

  const acceptLeave = () => {
    document.getElementById("back-link").click();
  };

  const toggleStep1ClassName = () => {
    document.getElementById("step-1-indicator").classList.add("active-step");
    document
      .getElementById("step-1-indicator")
      .classList.remove("finished-step");
    document.getElementById("step-2-indicator").classList.remove("active-step");
    document.getElementById("step-1").classList.remove("hidden");
    document.getElementById("step-2").classList.add("hidden");
    document.getElementById("step-1").classList.add("translated-step");
    setTimeout(() => {
      document.getElementById("step-1").classList.remove("translated-step");
    }, 450);
    setActiveStep(1);
  };

  const startSaveProcess = () => {
    saveCoreInfo();
  };

  const togglePublish = (JPAId) => {
    let Action;
    if (
      document
        .getElementById("created-jpa-icon-switch")
        .classList.contains("icon-switch-wrapper-active")
    ) {
      Action = "PUBLISH";
    } else {
      Action = "UNPUBLISH";
    }
    let ReqURL;
    let Id = JPAId;
    if (props.IsJob) {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/publish-unpublish";
    } else if (props.IsProject) {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/publish-unpublish";
    } else if (props.IsActivity) {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/preset/publish-unpublish";
    }
    let Req = {
      method: "POST",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        id: Id,
        action: Action,
      },
    };
    axios(Req)
      .then((Res) => {
        setHasUnsavedChanges(false);
        goToCandidates(JPAId);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const goToCandidates = (JPAId) => {
    window.localStorage.setItem("JPAInitialFilters", 1);
    setTimeout(() => {
      if (props.IsJob) {
        window.localStorage.setItem("CreatedJPAId", JPAId);
        document.getElementById("job-candidates-link").click();
      } else if (props.IsProject) {
        window.localStorage.setItem("CreatedJPAId", JPAId);
        document.getElementById("project-candidates-link").click();
      } else if (props.IsActivity) {
        window.localStorage.setItem("CreatedJPAId", JPAId);
        document.getElementById("activity-candidates-link").click();
      }
    }, 2500);
  };

  const saveCoreInfo = () => {
    setIsLoading(true);
    let JPAdata = {
      title: document.getElementById("title").value,
      description: document.getElementById("description").value,
      startDate: StartDate,
    };
    if (EndDate !== "") {
      JPAdata.endDate = EndDate;
    }
    // Availability date variables
    let AvailabilityValue;
    if (document.getElementById("value").value > 0) {
      AvailabilityValue = document.getElementById("value").value;
    }

    let AvailabilityUnit;
    if (document.getElementById("value").value > 0) {
      AvailabilityUnit = document.getElementById("avalability-filter").value;
    }

    if (AvailabilityValue) {
      JPAdata.availabilityValue = AvailabilityValue;
    }
    if (AvailabilityUnit) {
      JPAdata.availabilityUnit = AvailabilityUnit;
    }
    setJPACreated(true);
    setActiveStep(2);
    document.getElementById("jpa-title-text").innerHTML = JPAdata.title;
    toggleResults(JPAdata);
  };

  const toggleResults = (CoreInfo) => {
    setIsLoading(true);

    let Langs = [];
    SelectedLanguages.map((Language) => {
      Langs.push(Language.id);
    });

    let Locations = [];
    SelectedLocations.map((Loc) => {
      Locations.push(Loc.name);
    });

    let Skills = [];
    SelectedSkills.map((Skill) => {
      Skills.push(Skill.id);
    });

    let Educations = [];
    SelectedEd.map((Ed) => {
      Educations.push(Ed.name);
    });

    let Data = {
      title: CoreInfo.title,
      description: CoreInfo.description,
      startDate: CoreInfo.startDate,
      endDate: CoreInfo.endDate,
      availabilityValue: CoreInfo.availabilityValue,
      availabilityUnit: CoreInfo.availabilityUnit,
      languageIds: [...Langs],
      skillIds: [...Skills],
      cities: [...Locations],
      educations: Educations,
      yearsOfExperience: parseInt(
        document.getElementById("yoe-single").innerHTML
      ),
    };

    // /api/{project|position|activity}/preset/create-preset
    let ReqURL;
    if (props.JPAType === "job") {
      ReqURL = Config.PositionServiceURL + "/api/position/preset/create-preset";
    } else if (props.JPAType === "project") {
      ReqURL = Config.ProjectServiceURL + "/api/project/preset/create-preset";
    } else if (props.JPAType === "activity") {
      ReqURL = Config.ActivityServiceURL + "/api/activity/preset/create-preset";
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setCreatedJPAId(Res.data.id);
        if (
          document
            .getElementById("created-jpa-icon-switch")
            .classList.contains("icon-switch-wrapper-active")
        ) {
          togglePublish(Res.data.id);
        } else {
          goToCandidates(Res.data.id);
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const saveSelectedLangs = (SelectedLangs) => {
    setSelectedLanguages(SelectedLangs);
    setHasUnsavedChanges(true);
  };
  const saveSelectedLocations = (SelectedLocations) => {
    setSelectedLocations(SelectedLocations);
    setHasUnsavedChanges(true);
  };

  const saveSkill = (Skill) => {
    setSelectedSkills((prevState) => {
      const IsSkillSelected = prevState.find(
        (prevSkill) => prevSkill.id === Skill.id
      );

      if (IsSkillSelected) {
        return prevState.filter((prevSkill) => prevSkill.id !== Skill.id);
      }

      if (prevState.length >= 5) {
        return prevState;
      }

      return [...prevState, Skill];
    });
    setHasUnsavedChanges(true);
  };

  const removeSkill = (Skill) => {
    setSelectedSkills((prevState) =>
      prevState.filter((prevSkill) => prevSkill.id !== Skill.id)
    );
  };

  const saveEducation = (SelectedEds) => {
    setSelectedEd(SelectedEds);
    setHasUnsavedChanges(true);
  };

  const displayBreadCrump = () => {
    if (props.IsJob) {
      return (
        <div className="address">
          <NavLink hidden id="back-link" to="/createVacancies"></NavLink>
          <p>{translateText("jobs")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("create-vacancies")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("new_vacancy")}</p>
        </div>
      );
    } else if (props.IsProject) {
      return (
        <div className="address">
          <NavLink hidden id="back-link" to="/createProjects"></NavLink>
          <p>{translateText("projects")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("create_projects")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("new_project")}</p>
        </div>
      );
    } else {
      return (
        <div className="address">
          <NavLink hidden id="back-link" to="/createActivities"></NavLink>
          <p>{translateText("activities")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("create_activities")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("new_activity")}</p>
        </div>
      );
    }
  };

  const addOpenTriggerState = (Id) => {
    document.getElementById(Id).classList.add("trigger-open");
  };
  const removeOpenTriggerState = (Id) => {
    document.getElementById(Id).classList.remove("trigger-open");
  };

  useEffect(() => {
    const targetNode = document.getElementById("title");

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // watch the change of value of 'title'
    const observer = new MutationObserver((e) => {
      setTitle(e[0]?.target?.value || "");
    });

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }, []);

  return (
    <React.Fragment>
      <NavLink
        hidden
        to="/vacancyCandidates"
        id="job-candidates-link"
      ></NavLink>
      <NavLink
        hidden
        to="/projectCandidates"
        id="project-candidates-link"
      ></NavLink>
      <NavLink
        hidden
        to="/activityCandidates"
        id="activity-candidates-link"
      ></NavLink>
      <div className="content-header">{displayBreadCrump()}</div>
      <div className="create-jpa-form">
        {ModalIsOpen ? (
          <UnsavedChangesModal
            Close={() => setModalIsOpen(false)}
            AcceptLeave={() => acceptLeave()}
          />
        ) : null}
        <FormHead
          ToggleStep1={() => toggleStep1ClassName()}
          HeadText={props.HeadText}
          GoBack={() => goBack()}
          LangData={props.LangData}
        />
        <div id="step-1" className="step-wrapper">
          <Collapsible
            open={true}
            onOpen={() => addOpenTriggerState("step-1-trigger-mobile")}
            onClose={() => removeOpenTriggerState("step-1-trigger-mobile")}
            trigger={
              <section className="step-trigger">
                <h1>{translateText("core_information")}</h1>
                <span
                  className="step-trigger-btn trigger-open"
                  id="step-1-trigger-mobile"
                >
                  <i className="feather-chevron-down"></i>
                </span>
              </section>
            }
          >
            <MobileStep1
              UserInfo={props.UserInfo}
              JPAType={props.JPAType}
              SaveStartDate={(StartDate) => setStartDate(StartDate)}
              SaveEndDate={(EndDate) => setEndDate(EndDate)}
              SetHasUnsavedChanges={() => setHasUnsavedChanges(true)}
              SetHasNoUnsavedChanges={() => setHasUnsavedChanges(false)}
              LangData={props.LangData}
            />
          </Collapsible>
        </div>
        <div id="step-2" className="step-wrapper">
          <Collapsible
            onOpen={() => addOpenTriggerState("step-2-trigger-mobile")}
            onClose={() => removeOpenTriggerState("step-2-trigger-mobile")}
            trigger={
              <section className="step-trigger">
                <h1>{translateText("recom_criteria")}</h1>
                <span className="step-trigger-btn" id="step-2-trigger-mobile">
                  <i className="feather-chevron-down"></i>
                </span>
              </section>
            }
          >
            <MobileStep2
              EducationOptions={props.EducationOptions}
              Locations={props.Locations}
              Languages={props.Languages}
              JPAType={props.JPAType}
              SaveSelectedLangs={(SelectedLangs) =>
                saveSelectedLangs(SelectedLangs)
              }
              SaveSelectedLocations={(SelectedLocations) =>
                saveSelectedLocations(SelectedLocations)
              }
              SelectedSkills={SelectedSkills}
              SaveSkill={(Skill) => saveSkill(Skill)}
              RemoveSkill={(Skill) => removeSkill(Skill)}
              SaveSelectedEducation={(SelectedEds) =>
                saveEducation(SelectedEds)
              }
              LangData={props.LangData}
            />
          </Collapsible>
        </div>
      </div>
      <React.Fragment>
        {IsLoading ? (
          <span
            className="primary-action loading-btn"
            id="results-btn"
            onClick={() => null}
          >
            <img alt="" src={RotatorIcon} />
          </span>
        ) : (
          <span
            className={
              !Title ||
              !StartDate ||
              SelectedSkills.length === 0 ||
              SelectedSkills.length < 5
                ? "mobile-primary-action mobile-disabled-action"
                : "mobile-primary-action"
            }
            id="results-btn"
            onClick={() => startSaveProcess()}
          >
            {translateText("show_results")}
          </span>
        )}
      </React.Fragment>
    </React.Fragment>
  );
};

export default MobileView;
